/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <karolpawlak.giap@gmail.com>, May 2020
 */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../utils/utils';
import { Popover, OverlayTrigger, Col, strong, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/lib/Button';

const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const fileFormats = ['docx', 'pdf', 'jpg'];

const errorDict = {
  errorText: 'Załącznik musi być w formacie .docx, .pdf lub .jpg.',
  errorTitle: 'Błędny format pliku.',
  showError: true,
};

const emptyErrorDict = {
  errorText: null,
  errorTitle: null,
  showError: false,
};

const maxAttachmentsSize = 200.00;

const sizeErrorDict = {
  errorText: `Maksymalny łączny rozmiar załączników to ${maxAttachmentsSize}MB!`,
  errorTitle: 'Maksymalny rozmiar załączników przekroczony.',
  showError: true,
};

class AttachmentsPanel extends React.Component {
  state = {
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
    attachments: [],
    total_size: 0.00.toFixed(2),
  }

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
      };
    }
    this.setState({ colors, sourceStyle, style });
  }

  addAttachment = () => {
    this.setState({
      attachments: [...this.state.attachments, {
        name: '',
        extension: '',
        data: '',
        size: 0.00,
      }],
    }, () => this.calculateTotalSize(this.state.attachments, emptyErrorDict));
  }

  removeAttachment = (i, errorMessDict=null) => {
    const attachments = [...this.state.attachments];
    let errorMessageDict = emptyErrorDict;

    if (i > -1) {
      attachments.splice(i, 1);
    }

    if (errorMessDict) { errorMessageDict = errorMessDict; }
    this.setState({
      attachments,
    }, () => this.calculateTotalSize(attachments, errorMessageDict));
  }

  onAttachmentChange = async (e, idx) => {
    const file = e.target.files[0];
    const name = file.name;
    const extension = name.split('.').slice(-1)[0];
    const attachments = [...this.state.attachments];
    // convert bytes to MB
    const size = file.size / 1000000;
    let sizeError = false;
    if ((size + parseFloat(this.state.total_size)) > maxAttachmentsSize) { sizeError = true; }
    if (!sizeError && fileFormats.includes(extension)) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = event => {
        const data = event.target.result;
        attachments[idx] = { name, extension, data, size };
        this.setState({ attachments }, () => this.calculateTotalSize(attachments, emptyErrorDict));
      };
    } else if (sizeError) {
      this.removeAttachment(idx, sizeErrorDict);
    } else { this.removeAttachment(idx, errorDict); }
  }

  calculateTotalSize = (attachments, errorDict) => {
    let totalSize = 0.00;
    for (const attachment of this.state.attachments) {
      totalSize += attachment.size;
    }
    this.setState({ total_size: totalSize.toFixed(2) }, () => this.props.onChangeAttachments(attachments, errorDict));
  }

  render() {
    return (
      <div style={{ fontSize: `${this.props.fontSize}rem`, clear: 'both' }}>
        <div className="col-xs-12 col-mobile" >
          <div className={'grayPanel'} style={this.state.style}>
            <div className="basePanelHeading" style={this.state.style}>Załączniki</div>
            <div className="panel-body grayPanelBody">
              <Button
                className="btn btn-success"
                style={{ btnStyle }}
                onClick={() => this.addAttachment()}
              >
                  Dodaj załącznik
              </Button>
              <p><br />Wymagane formaty załączników: <b>.docx, .pdf, .jpg</b></p>
              <p>Maksymalny łączny rozmiar załączników: <b>{maxAttachmentsSize}MB</b></p>
              <p>Lista załączników:</p>
              {this.state.attachments.length < 1 ? <p style={{ textAlign: 'center' }}>Aby dodać załącznik, kliknij "Dodaj załącznik"</p> : null}
              {this.state.attachments.length > 0 ?
                <div className="col-lg-12">
                  <Row>
                    <Col xs={6} style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                      <p><b>Nazwa:</b></p>
                    </Col>
                    <Col xs={6} style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                      <p><b>Działania:</b></p>
                    </Col>
                  </Row>
                  {this.state.attachments.map((attachment, i) =>
                    <Row key={i}>
                      <Col xs={6} style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                        <input type="file" style={{ color: 'red' }} accept=".pdf,.docx,.jpg" onChange={(e) => this.onAttachmentChange(e, i)} />
                      </Col>
                      <Col xs={6} style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                        <Button
                          className="btn btn-danger"
                          onClick={() => this.removeAttachment(i)}
                        >
                          Usuń
                        </Button>
                      </Col>
                    </Row>,
                  )}
                </div> : null }
              <p>Łączny rozmiar załączników: <b>{this.state.total_size}MB</b></p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  fontSize: state.runtime.fontSize,
});

export default connect(mapState)(AttachmentsPanel);



// WEBPACK FOOTER //
// src/components/AttachmentsPanel/AttachmentsPanel.js